<!-- eslint-disable -->
<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Аккаунты</h3>
                        <div class="card-toolbar">
                            <b-button @click="showAddUser" variant="primary">Создать аккаунт</b-button>
                        </div>
                    </div>
                    <div class="card-body pt-0">

                        <div v-if="users.length === 0" class="text-center mb-10">
                            Аккаунты не найдены!
                        </div>

                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                        <b-form v-else>

                            <!--begin::Table-->
                            <div  class="table-responsive mt-3">
                                <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
                                    <thead>
                                    <tr class="text-left">
                                        <th class="pl-0">Имя</th>
                                        <th>Клиент</th>
                                        <th>Роли</th>
                                        <th>Дата регистрации
                                        <th class="pr-0 text-right">Действия</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <template v-for="(user, i) in users">
                                        <tr v-bind:key="i">
                                            <td class="pl-0">
                                                <div class="d-flex align-items-center">
                                                    <span v-if="user.image" class="symbol symbol-50 symbol-light-success mr-4">
                                                        <img :src="$urlBackEnd(user.image)" class="h-75" alt=""/>
                                                    </span>

                                                    <div v-else class="symbol symbol-50 symbol-light mr-4">
                                                        <span class="symbol-label">
                                                            <img src="/media/svg/avatars/032-boy-13.svg" class="h-75 align-self-end" alt=""/>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <router-link :to="{ name: 'EditAccount', params: {id: user.id}}" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{user.name}}</router-link>
                                                        <span class="text-muted font-weight-bold d-block">{{user.email}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span v-if="user.client" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                    <router-link :to="{ name: 'Client', params: {id: user.client.id}}">
                                                        {{ user.client.name + ' ' + user.client.surname }}
                                                    </router-link>
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="user.roles.length > 0" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                    <template v-for="role in user.roles">{{role.name}}
                                                    </template>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="text-primary font-weight-bolder d-block font-size-lg">
                                                    {{ moment(user.created_at).format('ll') }}
                                                </span>
                                            </td>
                                            <td class="pr-0 text-right">
                                                <router-link :to="{ name: 'EditAccount', params: {id: user.id}}" v-b-tooltip.hover title="Редактировать" class="btn btn-icon btn-light btn-hover-primary btn-sm"><i class="fas fa-edit"></i></router-link>
                                                <b-link @click="showModal(user.name,  user.id)" v-b-tooltip.hover title="Удалить" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-alt"></i></b-link>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                            <!--end::Table-->
                            <Paginate :route_link="'Accounts'" :filter="filter" />

                        </b-form>


                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="delete-modal" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить пользователя: {{modalUser.name}}?</h3>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" @click="closeModal" block >Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button ref="del-user" class="mt-3" variant="outline-danger" @click="deleteUser" block >Удалить</b-button>
                </b-col>
            </b-row>

        </b-modal>


        <b-modal ref="add-user" centered hide-footer title="Создать аккаунт">
            <div class="d-block">

                <b-form-group class="mb-2" label="Изображение">

                    <div v-if="new_user.image" class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                        <img :src="$urlBackEnd(new_user.image)" class="h-75" alt=""/>
                    </div>

                    <div v-else class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                        <img src="/media/svg/avatars/032-boy-13.svg" class="h-75 align-self-end" alt=""/>
                    </div>

                    <vue-dropzone ref="myVueDropzone"
                                  id="dropzone"
                                  :options="dropzoneOptions"
                                  :useCustomSlot=true
                                  v-on:vdropzone-success="successDrop"
                                  v-on:vdropzone-max-files-exceeded="maxDrop"
                    >
                        <div class="dropzone-custom-content">
                            <b class="dropzone-custom-title">Выберите файл</b>
                            <div class="subtitle">...или перетащите его сюда</div>
                        </div>

                    </vue-dropzone>

                    <b-button v-if="new_user.image" @click="deleteImage" size="sm" class="mt-3" variant="danger">Удалить изображение</b-button>
                </b-form-group>


                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите Имя" label="Имя:">
                        <b-form-input autocomplete="off" v-model.trim="new_user.name" :class="{'is-invalid': errors.name}" required></b-form-input>
                        <div v-if="errors.name" class="invalid-feedback">{{errors.name[0]}}</div>
                    </b-form-group>
                </div>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите email" label="Email:">
                        <b-form-input autocomplete="off" v-model.trim="new_user.email" :class="{'is-invalid': errors.email}" required></b-form-input>
                        <div v-if="errors.email" class="invalid-feedback">{{errors.email[0]}}</div>
                    </b-form-group>
                </div>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите пароль" label="Пароль:">
                        <b-form-input autocomplete="off" type="password" v-model="new_user.password" :class="{'is-invalid': errors.password}" required></b-form-input>
                        <div v-if="errors.password" class="invalid-feedback">{{errors.password[0]}}</div>
                    </b-form-group>
                </div>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите пароль еще раз" label="Подтвердите пароль:">
                        <b-form-input autocomplete="off" type="password" v-model="new_user.password_confirmation" :class="{'is-invalid': errors.password}" required></b-form-input>
                        <div v-if="errors.password" class="invalid-feedback">{{errors.password[0]}}</div>
                    </b-form-group>
                </div>

                <div class="card card-custom card-stretch gutter-b">

                    <!--begin::Header-->
                    <div class="card-header border-0 py-5">
                        <h3 class="card-title align-items-start flex-column">
                            <span class="card-label font-weight-bolder text-dark">Роли</span>
                            <span class="text-muted mt-3 font-weight-bold font-size-sm">
                    Роли пользователей определяют права доступа к функционалу сайта</span>
                        </h3>
                    </div>
                    <!--end::Header-->
                    <div class="card-body pt-0 pb-3">
                        <div class="row align-items-center mb-10">
                            <div class="col-lg-12 col-xl-12">
                                <div class="row align-items-center">
                                    <div class="col-md-6 my-2 my-md-0">
                                        <b-form-select
                                                class="mb-2 mr-sm-2 mb-sm-0"
                                                :value="null"
                                                v-model="add_role"
                                        >
                                            <option :value="null">Выберите роль</option>
                                            <template v-for="(role, i) in roles" >
                                                <option v-bind:key="i"
                                                        :value="role"
                                                        :disabled="disabledRoles(role.id)"
                                                >{{role.name}}</option>
                                            </template>
                                        </b-form-select>
                                    </div>
                                    <div class="col-md-6 my-2 my-md-0">
                                        <b-button @click="addRoleToUser" ref="add_role_user" variant="primary">Добавить роль</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div v-for="(role, i) in new_user.roles" class="row align-items-center mb-3 role mx-0">
                            <div v-bind:key="i" class="col-lg-12 col-xl-12">
                                <div class="row align-items-center">
                                    <div class="col-md-6 my-2 my-md-0">
                                        <h4>{{ role.name }}</h4>
                                    </div>

                                    <div class="col-md-6 my-2 my-md-0 text-right">
                                        <b-button @click="deleteRole(role.id)" size="sm" variant="danger">Удалить</b-button>
                                    </div>
                                </div>
                            </div>

                        </div>



                    </div>

                </div>

            </div>

            <b-button ref="add-user-button" class="mt-3" variant="outline-primary" block @click="addUser">Создать</b-button>

        </b-modal>



    </div>

</template>

<script>
    import { mapGetters } from "vuex";
    import moment from "moment";
    require('moment/locale/ru');
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {ADD_USER, DELETE_USER, GET_ROLES, GET_USERS} from "../../../core/services/store/users.module";
    import {SET_ALERT} from "../../../core/services/store/alert.module";
    import Paginate from "../Paginate";
    export default {
        name: "accounts",
        mounted(){
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Пользователи" }]);
            this.getFilter()
            
        },
        components: {
            Paginate,
            vueDropzone: vue2Dropzone
        },

        computed: {
            ...mapGetters({
                users: 'gettersUsers',
                load: 'getUserLoad',
                paginate: 'paginateGetters',
                errors: 'errorsUsers',
                roles: 'gettersRoles'
            })

        },

        data() {
            return {
                moment: moment,
                add_role: null,

                new_user: {
                    image: '',
                    name: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    roles: [],
                },

                edit_user: {
                    image: '',
                    name: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    roles: [],
                },

                filter: {
                    to: '50',
                    search: '',
                    role: null,

                    sort: 'data-new',
                    trashed: false,
                },


                dropzoneOptions: {
                    url: this.$urlBackEnd('/api/v1/image/user/image'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 8,
                    maxFiles:50,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },

                modalUser: {
                    name: '',
                    id: ''
                }
            }
        },

        methods:{


            async getFilter(){
                try {
                    await this.$store.dispatch(GET_USERS, {'page': this.$route.params.page, 'filter': this.filter});
                    if (this.users.length === 0 && this.paginate.total > 0){
                        this.$router.push({ name: 'Accounts', params: {page: 1}})
                    }
                } catch (e) {
                    this.showAlert('Ошибка загрузки', 'danger', 'toast');
                }
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            maxDrop (){
                this.showAlert('Не более одного файла', 'warning', 'toast');
            },

            successDrop (file, response) {
                this.$refs.myVueDropzone.removeAllFiles();

                this.new_user.image = response.original;
            },


            deleteImage(){
                this.new_user.image = null
            },

            disabledRoles(id){
                if (this.new_user.roles){
                    if (this.new_user.roles.find(obj => obj.id === id)){
                        return true
                    }
                }
            },

            deleteRole(id){
                var indexToRoles = this.new_user.roles.findIndex(obj => obj.id === id);
                this.new_user.roles.splice(indexToRoles , 1);
                this.showAlert('Роль успешно удалена ', 'success', 'toast');

            },

            showAddUser(){
                this.$store.dispatch(GET_ROLES)
                    .catch(() => {
                        this.showAlert('Ошибка загрузки ролей', 'warning', 'toast');
                    });
                this.$refs['add-user'].show()
            },

            addRoleToUser(){
                if (this.add_role){
                    if (!this.new_user.roles.find(obj => obj.id === this.add_role.id)){
                        this.new_user.roles.push(this.add_role);
                        this.add_role = null;
                        this.showAlert('Роль успешно добавлена ', 'success', 'toast');
                    }
                    else {
                        this.showAlert('Ошибка! Такая роль уже добавлена', 'danger', 'toast');
                    }
                } else {
                    this.showAlert('Необходимо выбрать роль', 'warning', 'toast');
                }
            },

            addUser(){



                const submitButtonAdd = this.$refs["add-user-button"];
                submitButtonAdd.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(ADD_USER, this.new_user)
                    .then(() => {
                        this.$store.dispatch(GET_USERS, {'page': this.$route.params.page, 'filter': this.filter});
                        this.$refs['add-user'].hide();
                        this.showAlert('Пользователь успешно добавлен', 'success', 'toast');
                        this.new_user = {
                            image: '',
                            name: '',
                            email: '',
                            password: '',
                            password_confirmation: '',
                            roles: [],
                        };
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                    submitButtonAdd.classList.remove("spinner", "spinner-light", "spinner-right")
                });
            },

            showModal(name, id) {
                this.modalUser = {
                    name: name,
                    id: id
                };

                this.$refs['delete-modal'].show()
            },

            closeModal() {
                this.$refs['delete-modal'].hide();
            },

            deleteUser(){
                const submitButtonDel = this.$refs["del-user"];
                submitButtonDel.classList.add("spinner", "spinner-light", "spinner-right");



                this.$store.dispatch(DELETE_USER, this.modalUser.id)
                    .then(() => {
                        this.$refs['delete-modal'].hide();
                        this.showAlert('Пользователь успешно удален', 'success', 'toast');
                        this.$store.dispatch(GET_USERS, {'page': this.$route.params.page, 'filter': this.filter});
                    })
                    .catch(() => {
                        this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                    })
                    .finally(() => {
                        submitButtonDel.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            }


        },

        watch: {

            $route: function () {
                this.getFilter()
            },

            "filter.to": function() {
                this.getFilter()
            },
        }

    }
</script>

<style scoped>
    .role{
        background-color: #f3f6f9;
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 3px;
    }
</style>